import { DirectionalLight, AmbientLight } from 'three';

export function createLights() {
  const light = new DirectionalLight('blue', 3.5)

  light.position.set(11, 2, -9)

  return light;
}